<template>
	<div style="margin: 0 20px; background-color: #fff;height: 85vh;padding: 20px;">
		<el-form label-position="right" label-width="80px" :model="reqData">
		  <el-form-item label="公司名称">
			<el-input v-model="reqData.companyName"></el-input>
		  </el-form-item>
		  <el-form-item label="公司地址">
			<el-input v-model="reqData.companyAddress"></el-input>
		  </el-form-item>
		  <el-form-item label="营业执照">
			<el-upload
			  class="avatar-uploader"
			  :data="uploadData"
			  action="/api/minio/upload"
			  :show-file-list="false"
			  :on-success="handleAvatarSuccess"
			  :before-upload="beforeAvatarUpload">
			  <img v-if="reqData.license" :src="reqData.license" class="avatar">
			  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
		  </el-form-item>
		  <el-form-item label="联系人">
			<el-input v-model="reqData.responsibleName"></el-input>
		  </el-form-item>
		  <el-form-item label="联系号码">
			<el-input v-model="this.$store.getters.getUser.phone" :disabled="true"></el-input>
		  </el-form-item>
		  <el-form-item>
			  <el-button type="primary" @click="onSubmit">确认修改</el-button>
		  </el-form-item>
		</el-form>
	</div>
</template>

<script>
	import { mapActions } from "vuex";
	export default {
		...mapActions(["updateUser"]),
	    data() {
	      return {
			uploadData:{
				bucketName:'license'
			},
			reqData:{
				companyName:"",
				companyAddress:"",
				responsibleName:"",
				license:""
			}
	      };
	    },
		mounted() {
			this.reqData.companyName = this.$store.getters.getUser.companyName;
			this.reqData.companyAddress = this.$store.getters.getUser.companyAddress;
			this.reqData.responsibleName = this.$store.getters.getUser.responsibleName;
			this.reqData.license = this.$store.getters.getUser.license;
		},
	    methods: {
		  beforeAvatarUpload(file){
		  	const houzhui = ['image/jpeg','image/png','image/bmp','image/webp','image/jpg']
		  	const isJPG = houzhui.includes(file.type);
		  	const isLt2M = file.size / 1024 / 1024 < 2;
		  		
		  	if (!isJPG) {
		  	  this.$message.error('上传头像图片只能是 JPG 格式!');
		  	}
		  	if (!isLt2M) {
		  	  this.$message.error('上传头像图片大小不能超过 2MB!');
		  	}
		  	return isJPG && isLt2M;
		  },
		  handleAvatarSuccess(res, file){
		  	this.reqData.license = res.data.url;
		  },
		  onSubmit(){
			  if(!this.reqData.companyName){
			  	this.notifyError("请填写公司名称");
			  	return
			  }else if(!this.reqData.companyAddress){
			  	this.notifyError("请填写公司地址");
			  	return
			  }else if(!this.reqData.responsibleName){
			  	this.notifyError("请填写联系人姓名");
			  	return
			  }else if(!this.reqData.license){
			  	this.notifyError("请上传营业执照");
			  	return
			  }
			this.$axios.post("/api/user/backend/updateBusinessesInfo", this.reqData).then(res => {
			    if (res.data.code === "200" || res.data.code === 200) {
					// 登录信息存到vuex
					this.$store.commit("updateUser",this.reqData)
					// 登录信息存到本地
					let user = JSON.stringify(this.$store.getters.getUser);
					localStorage.setItem("user", user);
					// 提示成功信息
					this.notifySucceed("修改成功");
			    } else {
					// 提示失败信息
					this.notifyError(res.data.msg);
			    }
			}).catch(err => {
			    return Promise.reject(err);
			});
		  }
	    }
	  };
</script>

<style>
	.avatar-uploader  {
	    border: 1px dashed #a1a1a1;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
		text-align: center;
		width: 150px;
		height: 150px;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #a1a1a1;
	    width: 150px;
	    height: 150px;
	    line-height: 150px;
	    text-align: center;
	  }
	  .avatar {
	    width: 150px;
	    height: 150px;
	    display: block;
	  }
</style>